// extracted by mini-css-extract-plugin
export default {"jewelryPage":"JWorksPage_jewelryPage__2xFax"};